// import { navigations } from 'app/navigations'
// import { SET_USER_NAVIGATION } from '../actions/NavigationAction'

// const initialState = [...navigations]

// const NavigationReducer = function (state = initialState, action) {

//     switch (action.type) {
   
//         case SET_USER_NAVIGATION: {
//             return [...action.payload.filteredNavigations]
//         }
//         default: {
//             return [...state]
//         }
//     }
// }

// export default NavigationReducer

import { createSlice } from '@reduxjs/toolkit';
import { navigations } from 'app/navigations';

const initialState = [...navigations];

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setUserNavigation(state, action) {
      return [...action.payload.filteredNavigations];
    },
  },
});

export const { setUserNavigation } = navigationSlice.actions;

export default navigationSlice.reducer;
